'use strict';

const loader = require('friartux/components/loader');

const SELECTORS = {
    body: 'body',
    // Saved look card buttons that navigate to Cart-Show?lookId=... to load the
    // look into the cart (review = read only, edit = editable).
    loadLookBtn: '.c-card-button--review, .c-card-button--edit'
};

/**
 * Show the full-page loading overlay before the browser navigates to the saved
 * look in the cart. This reuses the PDP add to cart loader; the overlay is left
 * running until the page navigates away, mirroring the PDP redirect behaviour.
 * @param {Event} e - Click event
 * @returns {void}
 */
const handleLoadLookBtnClick = (e) => {
    // Ignore modified clicks (open in new tab/window, middle click) so the
    // current page isn't left with a stuck overlay.
    if (e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
    }

    loader.start();
};

/**
 * Init events.
 * @returns {void}
 */
function handleLoadSavedLook() {
    $(SELECTORS.body).on('click', SELECTORS.loadLookBtn, handleLoadLookBtnClick);
}

module.exports = {
    handleLoadSavedLook: handleLoadSavedLook
};
